import { Directive, Input, TemplateRef } from '@angular/core';
import { Claims } from '@core/authentication/claims';

@Directive({
  selector: '[country]'
})
export class CountryDirective {
  @Input() country!: `${Claims.Country}`;
  constructor(public templateRef: TemplateRef<unknown>) {}
}
